const rootId = -1
const stubRootFolder = (name) => ({
  id: rootId,
  name,
  root: true
})

/**
 * Returns a root folders map with the root name as its key.
 * @return {Object}
 */
export default () => {
  const folderMap = {
    allActivities: stubRootFolder('All activities'),
    activities: stubRootFolder('Activities'),
    shared: stubRootFolder('Shared with me'),
    account: stubRootFolder('Presenters'),
    trash: stubRootFolder('Trash')
  }

  // This just adds the `key` to each object in the map.
  return Object.fromEntries(
    Object.entries(folderMap)
      .map(([key, obj]) => [key, Object.assign(obj, { key })])
  )
}

/**
 * Returns whether the specified folder entity or ID is a root folder.
 * @param {Object|number} folderOrId Folder entity or ID
 * @return {boolean}
 */
export const isRoot = (folderOrId) =>
  folderOrId === rootId || folderOrId?.id === rootId
